import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge, validators } from "tailwind-merge";

// 안전 영역 유틸(web globals.css 의 pt-safe·pt-safe-4·pb-safe·pl-safe·scroll-mt-safe-16) — 알려 주지 않으면 pt-4 와 둘 다 남아 뒤에 넘긴 쪽이 이기지 못한다.
const SAFE = [{ safe: ["", validators.isNumber] }];

// styles.css @theme 의 글자 크기 중 xs~9xl·md·base 는 기본 규칙이 알고, text-print-xs 만 알려 줘야 색으로 오인해 지우지 않는다.
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ["print-xs"],
    },
    classGroups: {
      pt: [{ pt: SAFE }],
      pb: [{ pb: SAFE }],
      pl: [{ pl: SAFE }],
      "scroll-mt": [{ "scroll-mt": SAFE }],
    },
  },
});

export const cn = (...inputs: ClassValue[]) => {
  return twMerge(clsx(inputs));
};
